import React from 'react';

const Footer = () => {
    return (
        <footer style={styles.footer}>
            <div style={styles.container}>
                <div style={styles.content}>
                    <div style={styles.brandSection}>
                        <div style={styles.logoContainer}>
                            <span style={styles.logoIcon}>🍽️</span>
                            <span style={styles.logo}>Delicious</span>
                        </div>
                        <p style={styles.brandText}>
                            Creating memorable dining experiences since 2010.
                            Where passion meets culinary excellence.
                        </p>
                        <div style={styles.social}>
                            <a href="#" style={styles.socialLink}>📘</a>
                            <a href="#" style={styles.socialLink}>📷</a>
                            <a href="#" style={styles.socialLink}>🐦</a>
                            <a href="#" style={styles.socialLink}>📺</a>
                        </div>
                    </div>

                    <div style={styles.linksSection}>
                        <div style={styles.column}>
                            <h4 style={styles.columnTitle}>Quick Links</h4>
                            <ul style={styles.list}>
                                <li style={styles.listItem}>About Us</li>
                                <li style={styles.listItem}>Our Menu</li>
                                <li style={styles.listItem}>Reservations</li>
                                <li style={styles.listItem}>Catering</li>
                                <li style={styles.listItem}>Gift Cards</li>
                            </ul>
                        </div>

                        <div style={styles.column}>
                            <h4 style={styles.columnTitle}>Support</h4>
                            <ul style={styles.list}>
                                <li style={styles.listItem}>FAQ</li>
                                <li style={styles.listItem}>Contact Us</li>
                                <li style={styles.listItem}>Careers</li>
                                <li style={styles.listItem}>Privacy Policy</li>
                                <li style={styles.listItem}>Terms of Service</li>
                            </ul>
                        </div>

                        <div style={styles.column}>
                            <h4 style={styles.columnTitle}>Newsletter</h4>
                            <p style={styles.newsletterText}>
                                Subscribe to get special offers and updates
                            </p>
                            <div style={styles.newsletterForm}>
                                <input
                                    type="email"
                                    placeholder="Your email"
                                    style={styles.newsletterInput}
                                />
                                <button style={styles.newsletterButton}>→</button>
                            </div>
                            <div style={styles.badges}>
                                <span style={styles.badge}>⭐ 4.9 Rating</span>
                                <span style={styles.badge}>🏆 Award Winner</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div style={styles.bottom}>
                    <p style={styles.copyright}>
                        © 2024 Delicious Resto. All rights reserved. Made with ❤️
                    </p>
                    <div style={styles.paymentIcons}>
                        <span style={styles.paymentIcon}>💳</span>
                        <span style={styles.paymentIcon}>💰</span>
                        <span style={styles.paymentIcon}>📱</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

const styles = {
    footer: {
        backgroundColor: '#1a1a1a',
        color: 'var(--white)',
        padding: '4rem 2rem 2rem',
    },
    container: {
        maxWidth: '1400px',
        margin: '0 auto',
    },
    content: {
        display: 'grid',
        gridTemplateColumns: '1.5fr 2fr',
        gap: '4rem',
        marginBottom: '3rem',
        paddingBottom: '3rem',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
    },
    brandSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
    },
    logoContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
    },
    logoIcon: {
        fontSize: '2rem',
    },
    logo: {
        fontSize: '2rem',
        fontWeight: '800',
        color: 'var(--white)',
    },
    brandText: {
        fontSize: '1rem',
        lineHeight: '1.7',
        color: 'rgba(255,255,255,0.7)',
        maxWidth: '350px',
    },
    social: {
        display: 'flex',
        gap: '1rem',
    },
    socialLink: {
        width: '45px',
        height: '45px',
        borderRadius: '12px',
        backgroundColor: 'rgba(255,255,255,0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '1.3rem',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        textDecoration: 'none',
    },
    linksSection: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '2rem',
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
    },
    columnTitle: {
        fontSize: '1.2rem',
        fontWeight: '700',
        marginBottom: '1.5rem',
        color: 'var(--white)',
    },
    list: {
        listStyle: 'none',
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '0.8rem',
    },
    listItem: {
        fontSize: '0.95rem',
        color: 'rgba(255,255,255,0.7)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
    },
    newsletterText: {
        fontSize: '0.95rem',
        color: 'rgba(255,255,255,0.7)',
        marginBottom: '1rem',
        lineHeight: '1.6',
    },
    newsletterForm: {
        display: 'flex',
        gap: '0.5rem',
        marginBottom: '1.5rem',
    },
    newsletterInput: {
        flex: 1,
        padding: '0.9rem 1.2rem',
        border: '2px solid rgba(255,255,255,0.2)',
        borderRadius: '10px',
        backgroundColor: 'rgba(255,255,255,0.05)',
        color: 'var(--white)',
        fontSize: '0.95rem',
        outline: 'none',
    },
    newsletterButton: {
        width: '50px',
        backgroundColor: 'var(--maroon)',
        border: 'none',
        borderRadius: '10px',
        color: 'var(--white)',
        fontSize: '1.5rem',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
    },
    badges: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
    },
    badge: {
        display: 'inline-block',
        padding: '0.5rem 1rem',
        backgroundColor: 'rgba(255,255,255,0.1)',
        borderRadius: '8px',
        fontSize: '0.85rem',
        fontWeight: '600',
    },
    bottom: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '1rem',
    },
    copyright: {
        fontSize: '0.95rem',
        color: 'rgba(255,255,255,0.6)',
    },
    paymentIcons: {
        display: 'flex',
        gap: '1rem',
    },
    paymentIcon: {
        fontSize: '1.8rem',
        opacity: 0.7,
    },
};

export default Footer;